import { getSelectedTopicId } from 'reduxes/slices/selected/selectors'
import { createSelector } from 'reselect'

const getHasMore = (state, key) => state?.paging?.[key]?.hasMore
const getFilter = (state, key) => state?.paging?.[key]?.filter
const getMatches = (state, key) => state.paging?.[key]?.matches

export const getContactsHasMore = (state) =>
  getHasMore(state, 'contacts')

export const getTopicMatches = (state) =>
  getMatches(state, 'group_chats')

export const getSearchFilter = (state) => getFilter(state, 'search')

const emptyObj = {}

const getTimelinesPagingLookup = (state) => state?.paging?.timelines
export const getTopicsPaging = (state) => state?.paging?.group_chats
export const getLiveChatsPaging = (state) => state?.paging?.live_chats

export const getTimelinesPaging = createSelector(
  [getSelectedTopicId, getTimelinesPagingLookup],
  (topicId, paging) => {
    return paging?.[topicId] || emptyObj
  },
)
